import { Body1 } from '@cian/ui-kit';
import { IconActionCopy16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './styles.css';
import { copyToClipboard } from '../../../utils/copyToClipboard';

type TUserCardDesktopPhoneProps = {
  phone: string;
  onClick(): void;
};

export const UserCardDesktopPhone: React.FC<TUserCardDesktopPhoneProps> = ({ phone, onClick }) => {
  const handleOnClick = React.useCallback(() => {
    copyToClipboard(phone);
    onClick();
  }, [onClick, phone]);

  return (
    <div className={styles['container']} data-testid="UserCardDesktopPhone">
      <Body1>{phone}</Body1>
      <button onClick={handleOnClick} className={styles['action']}>
        <IconActionCopy16 color="icon-secondary-default" />
      </button>
    </div>
  );
};
